<template>
  <div class="about">
    <div class="container banner">
      <img src="../../static/img/about/banner.png" class="top-banner" alt="">
      <div class="content">
        <div class="bread">
          您现在的位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >关于合美</el-breadcrumb-item>
            <el-breadcrumb-item>联系我们</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="about-title">
          <h3 class="meal-title"><span class="title-line"></span>联系我们<span class="title-line"></span></h3>
          <p class="sub-title">Contact Information</p>
        </div>
        <div class="about-article">
          <router-link to="" class="top-banner">
            <img src="../../static/img/about/banner-us.png" alt="">
          </router-link>
          <div class="cont">
            <div class="cont-text">
              <p class="name">常州合美母婴护理有限公司</p>
              <p class="title">24小时咨询联系</p>
              <p class="number">13921031020 &nbsp; 陆女士</p>
              <p class="title">咨询电话</p>
              <p class="number">0519--86957666</p>
              <p class="title">联系邮箱</p>
              <p class="number">582515087@qq.com</p>
              <p class="name">地址：常州市武进区武宜南路698号-15号</p>
              <img src="../../static/img/about/erweima.png" alt="">
            </div>
            <img src="../../static/img/about/map.png" class="map" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "aboutUs",
    data(){
      return{

      }
    },
  }
</script>

<style scoped lang="less">
  .about{
    .banner{
      .top-banner{
        width: 100%;
        margin-bottom: 20px;
      }
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .about-title{
        margin-bottom: 32px;
      }
      .about-article{
        margin-bottom: 80px;
        .top-banner{
          display: block;
          width: 100%;
          height: 332px;
          margin-bottom: 30px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .cont{
          display: flex;
          justify-content: space-between;
          width: 100%;
          .cont-text{
            font-size: 16px;
            color:#333333;
            line-height: 18px;
            .name{
              margin-bottom: 42px;
            }
            .title{
              margin-bottom: 8px;
            }
            .number{
              font-size: 20px;
              line-height: 28px;
              color:#AA7633;
              margin-bottom: 30px;
            }
          }
        }
      }
    }
  }
  .meal-title{
    margin-bottom: 8px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .sub-title{
    color:#b3b3ba;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/aboutUs.vue